import { useState } from "react"
import { useTemplateData } from "src/Context/TemplateData.context"
import HierarchyPathDisplay from "src/components/HierarchyPathDisplay"
import { hierarchyTopicKey } from "src/utils/hierarchyTopic"

const QuestionConfig = () => {
  const { topicGroup, setTopicGroup, selectedSubjectMeta } = useTemplateData()
  const [selectedTab, setSelectedTab] = useState(0)

  const handleAddQuestion = (groupIndex: number, topicIndex: number) => {
    setTopicGroup((prev) => {
      const newGroup = [...prev]
      const newTopics = [...newGroup[groupIndex].topics]
      const newQuestions = [...newTopics[topicIndex].questions]

      newQuestions.push({
        complexity: "medium",
        number: 1,
      })

      newTopics[topicIndex] = {
        ...newTopics[topicIndex],
        questions: newQuestions,
      }

      newGroup[groupIndex] = {
        ...newGroup[groupIndex],
        topics: newTopics,
      }

      return newGroup
    })
  }

  const updateQuestion = (
    groupIndex: number,
    topicIndex: number,
    questionIndex: number,
    key: "complexity" | "number",
    value: any
  ) => {
    setTopicGroup((prev) => {
      const newGroup = [...prev]
      const newTopics = [...newGroup[groupIndex].topics]
      const newQuestions = [...newTopics[topicIndex].questions]

      newQuestions[questionIndex] = {
        ...newQuestions[questionIndex],
        [key]: value,
      }

      newTopics[topicIndex] = {
        ...newTopics[topicIndex],
        questions: newQuestions,
      }

      newGroup[groupIndex] = {
        ...newGroup[groupIndex],
        topics: newTopics,
      }

      console.log({ newGroup }, "this is data")

      return newGroup
    })
  }

  const removeQuestion = (
    groupIndex: number,
    topicIndex: number,
    questionIndex: number
  ) => {
    setTopicGroup((prev) => {
      const newGroup = [...prev]
      const newTopics = [...newGroup[groupIndex].topics]
      const newQuestions = [...newTopics[topicIndex].questions]

      newQuestions.splice(questionIndex, 1)

      newTopics[topicIndex] = {
        ...newTopics[topicIndex],
        questions: newQuestions,
      }

      newGroup[groupIndex] = {
        ...newGroup[groupIndex],
        topics: newTopics,
      }

      return newGroup
    })
  }

  return (
    <div className='question_config'>
      <div className='question_config_container'>
        <div className='side_bar'>
          {topicGroup.map((group, groupIndex) => (
            <div
              key={groupIndex}
              className={`nav_subject ${
                selectedTab === groupIndex ? "active" : ""
              }`}
              onClick={() => setSelectedTab(groupIndex)}
            >
              {group.name || `Group ${groupIndex + 1}`}
            </div>
          ))}
        </div>

        <div className='question_config_content'>
          {topicGroup[selectedTab]?.topics?.map((topic, topicIndex) => {
            return (
              <div
                key={hierarchyTopicKey(topic)}
                className='mb-4 bg-white border border-gray-200 rounded w-full'
              >
                <div className='flex justify-between '>
                  <div className='w-1/2 text-left px-3 py-2'>
                    <HierarchyPathDisplay
                      topic={topic}
                      levelLabels={selectedSubjectMeta?.level_labels}
                      variant="rows"
                    />
                  </div>
                  <div className='text-right flex justify-end'>
                    <button
                      type='button'
                      className='flex items-center gap-1 px-3 py-2 bg-white rounded-[8px]'
                      onClick={() => handleAddQuestion(selectedTab, topicIndex)}
                    >
                      <span className='text-xl font-bold text-[#344054]'>
                        +
                      </span>
                      <span className="text-[14px] leading-[20px] font-medium text-[#344054] font-['Plus Jakarta Sans']">
                        Add Question
                      </span>
                    </button>
                  </div>
                </div>

                <div className='flex flex-wrap gap-4 mt-2 bg-gray-100 p-2 rounded-lg'>
                  {topic.questions.map((q, qIndex) => (
                    <div
                      key={qIndex}
                      className='flex items-center gap-2 bg-gray-200 p-2 rounded-lg border border-gray-300'
                    >
                      <span className="text-white bg-gray-700 px-2 py-1 rounded text-sm font-semibold font-['Plus Jakarta Sans']">
                        {qIndex + 1 < 10 ? `0${qIndex + 1}` : qIndex + 1}
                      </span>

                      <select
                        value={q.complexity}
                        onChange={(e) =>
                          updateQuestion(
                            selectedTab,
                            topicIndex,
                            qIndex,
                            "complexity",
                            e.target.value
                          )
                        }
                        className="border border-gray-300 rounded px-2 py-1 text-sm text-gray-800 font-semibold font-['Plus Jakarta Sans']"
                      >
                        <option value='easy'>Easy</option>
                        <option value='medium'>Medium</option>
                        <option value='hard'>Hard</option>
                      </select>

                      <input
                        type='number'
                        min={1}
                        max={20}
                        value={q.number}
                        onChange={(e) =>
                          updateQuestion(
                            selectedTab,
                            topicIndex,
                            qIndex,
                            "number",
                            parseInt(e.target.value)
                          )
                        }
                        className='border border-gray-300 rounded py-1 text-sm text-gray-800 font-semibold text-center'
                      />

                      <button
                        type='button'
                        className='flex items-center gap-1 text-red-600 font-semibold text-2xl'
                        title='Remove'
                        onClick={() =>
                          removeQuestion(selectedTab, topicIndex, qIndex)
                        }
                      >
                        ×
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default QuestionConfig
